import React from 'react';
import { observer } from 'mobx-react';
import styles from './styles.m.sass';
export default observer(function DepartingMessageBubble(_ref) {
  var displayName = _ref.displayName;
  return /*#__PURE__*/React.createElement("div", {
    className: styles.bubbleContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.bubble
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.content
  }, displayName, " has left the conversation")));
});
//# sourceMappingURL=index.js.map
